// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Using same color variables from navbar */
:root {
  --primary-gray: #d9d9d9;
  --white: #ffffff;
  --black: #000000;
  --transparent: rgba(255, 255, 255, 0.1);
  --dark-bg: rgba(0, 0, 0, 0.9);
}

.footer {
  background: var(--black);
  color: var(--primary-gray);
  border-top: 1px solid rgba(217, 217, 217, 0.1);
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 3rem 0 2rem;
}

/* Company Column */
.footer-company {
  grid-column: 1 / 2;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.footer-logo .logo-f {
  background: var(--white);
  color: var(--black);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: bold;
}

.footer-logo .logo-text {
  color: var(--white);
  font-size: 1.1rem;
  letter-spacing: 2px;
  font-weight: 300;
}

.footer-description {
  margin-bottom: 1.5rem;
  line-height: 1.6;
  font-size: 0.9rem;
  opacity: 0.8;
}

.footer-social {
  display: flex;
  gap: 1rem;
}

.footer-social a {
  color: var(--primary-gray);
  transition: all 0.3s ease;
  padding: 0.5rem;
  border-radius: 50%;
  background: rgba(217, 217, 217, 0.1);
}

.footer-social a:hover {
  color: var(--white);
  background: rgba(217, 217, 217, 0.2);
  transform: translateY(-2px);
}

/* Footer Columns */
.footer-column {
  display: flex;
  flex-direction: column;
}

.footer-title {
  color: var(--white);
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
}

.footer-list {
  list-style: none;
  padding: 0;
}

.footer-list li {
  margin-bottom: 0.75rem;
}

.footer-list li a {
  color: var(--primary-gray);
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 0;
}

.footer-list li a:hover {
  color: var(--white);
  padding-left: 0.5rem;
}

.footer-list li a::before {
  content: '';
  position: absolute;
  left: -0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 1px;
  background: var(--white);
  transition: width 0.3s ease;
}

.footer-list li a:hover::before {
  width: 0.25rem;
}

/* Contact Column */
.contact-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.contact-item:hover {
  color: var(--white);
}

.contact-item svg {
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.contact-item:hover svg {
  opacity: 1;
}

/* Legal Images Column */
.footer-images {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}

.footer-image {
  max-height: 60px;
  width: auto;
  opacity: 0.8;
  transition: all 0.3s ease;
  filter: brightness(0.9);
}

.footer-images a:hover .footer-image {
  opacity: 1;
  transform: translateY(-2px);
  filter: brightness(1.1);
}

/* Footer Bottom */
.footer-bottom {
  border-top: 1px solid rgba(217, 217, 217, 0.1);
  padding: 1.5rem 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-copyright {
  font-size: 0.85rem;
  opacity: 0.7;
  margin: 0;
}

.footer-legal {
  display: flex;
  gap: 1.5rem;
}

.footer-legal a {
  color: var(--primary-gray);
  text-decoration: none;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  opacity: 0.7;
}

.footer-legal a:hover {
  color: var(--white);
  opacity: 1;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    padding: 0 1.5rem;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 2rem 0 1.5rem;
  }
  
  .footer-company {
    grid-column: 1;
    text-align: center;
  }
  
  .footer-social {
    justify-content: center;
  }
  
  .footer-images {
    align-items: center;
    flex-direction: row;
    justify-content: center;
    gap: 2rem;
  }
  
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .footer-legal {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 0 1rem;
  }
  
  .footer-content {
    padding: 1.5rem 0 1rem;
    gap: 1.5rem;
  }
  
  .footer-title {
    font-size: 1rem;
  }
  
  .footer-images {
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-legal {
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
  }
}

/* Animation for footer elements on scroll */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footer-column {
  animation: fadeInUp 0.6s ease forwards;
}

.footer-column:nth-child(1) { animation-delay: 0.1s; }
.footer-column:nth-child(2) { animation-delay: 0.2s; }
.footer-column:nth-child(3) { animation-delay: 0.3s; }
.footer-column:nth-child(4) { animation-delay: 0.4s; }
.footer-column:nth-child(5) { animation-delay: 0.5s; }

/* Hover effect for footer sections */
.footer-column:not(.footer-company):hover {
  transform: translateY(-2px);
  transition: transform 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA,8BAA8B,qBAAqB,EAAE;AACrD,8BAA8B,qBAAqB,EAAE;AACrD,8BAA8B,qBAAqB,EAAE;AACrD,8BAA8B,qBAAqB,EAAE;AACrD,8BAA8B,qBAAqB,EAAE;;AAErD,qCAAqC;AACrC;EACE,2BAA2B;EAC3B,+BAA+B;AACjC","sourcesContent":["/* Using same color variables from navbar */\n:root {\n  --primary-gray: #d9d9d9;\n  --white: #ffffff;\n  --black: #000000;\n  --transparent: rgba(255, 255, 255, 0.1);\n  --dark-bg: rgba(0, 0, 0, 0.9);\n}\n\n.footer {\n  background: var(--black);\n  color: var(--primary-gray);\n  border-top: 1px solid rgba(217, 217, 217, 0.1);\n  margin-top: auto;\n}\n\n.footer-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  padding: 3rem 0 2rem;\n}\n\n/* Company Column */\n.footer-company {\n  grid-column: 1 / 2;\n}\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.footer-logo .logo-f {\n  background: var(--white);\n  color: var(--black);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.footer-logo .logo-text {\n  color: var(--white);\n  font-size: 1.1rem;\n  letter-spacing: 2px;\n  font-weight: 300;\n}\n\n.footer-description {\n  margin-bottom: 1.5rem;\n  line-height: 1.6;\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.footer-social {\n  display: flex;\n  gap: 1rem;\n}\n\n.footer-social a {\n  color: var(--primary-gray);\n  transition: all 0.3s ease;\n  padding: 0.5rem;\n  border-radius: 50%;\n  background: rgba(217, 217, 217, 0.1);\n}\n\n.footer-social a:hover {\n  color: var(--white);\n  background: rgba(217, 217, 217, 0.2);\n  transform: translateY(-2px);\n}\n\n/* Footer Columns */\n.footer-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-title {\n  color: var(--white);\n  font-size: 1.1rem;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  letter-spacing: 0.5px;\n}\n\n.footer-list {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-list li {\n  margin-bottom: 0.75rem;\n}\n\n.footer-list li a {\n  color: var(--primary-gray);\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  position: relative;\n  padding-left: 0;\n}\n\n.footer-list li a:hover {\n  color: var(--white);\n  padding-left: 0.5rem;\n}\n\n.footer-list li a::before {\n  content: '';\n  position: absolute;\n  left: -0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 1px;\n  background: var(--white);\n  transition: width 0.3s ease;\n}\n\n.footer-list li a:hover::before {\n  width: 0.25rem;\n}\n\n/* Contact Column */\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.contact-item:hover {\n  color: var(--white);\n}\n\n.contact-item svg {\n  opacity: 0.7;\n  transition: opacity 0.3s ease;\n}\n\n.contact-item:hover svg {\n  opacity: 1;\n}\n\n/* Legal Images Column */\n.footer-images {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.footer-image {\n  max-height: 60px;\n  width: auto;\n  opacity: 0.8;\n  transition: all 0.3s ease;\n  filter: brightness(0.9);\n}\n\n.footer-images a:hover .footer-image {\n  opacity: 1;\n  transform: translateY(-2px);\n  filter: brightness(1.1);\n}\n\n/* Footer Bottom */\n.footer-bottom {\n  border-top: 1px solid rgba(217, 217, 217, 0.1);\n  padding: 1.5rem 0;\n}\n\n.footer-bottom-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.footer-copyright {\n  font-size: 0.85rem;\n  opacity: 0.7;\n  margin: 0;\n}\n\n.footer-legal {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.footer-legal a {\n  color: var(--primary-gray);\n  text-decoration: none;\n  font-size: 0.85rem;\n  transition: all 0.3s ease;\n  opacity: 0.7;\n}\n\n.footer-legal a:hover {\n  color: var(--white);\n  opacity: 1;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .footer-container {\n    padding: 0 1.5rem;\n  }\n  \n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    padding: 2rem 0 1.5rem;\n  }\n  \n  .footer-company {\n    grid-column: 1;\n    text-align: center;\n  }\n  \n  .footer-social {\n    justify-content: center;\n  }\n  \n  .footer-images {\n    align-items: center;\n    flex-direction: row;\n    justify-content: center;\n    gap: 2rem;\n  }\n  \n  .footer-bottom-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n  \n  .footer-legal {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-container {\n    padding: 0 1rem;\n  }\n  \n  .footer-content {\n    padding: 1.5rem 0 1rem;\n    gap: 1.5rem;\n  }\n  \n  .footer-title {\n    font-size: 1rem;\n  }\n  \n  .footer-images {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .footer-legal {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: center;\n  }\n}\n\n/* Animation for footer elements on scroll */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.footer-column {\n  animation: fadeInUp 0.6s ease forwards;\n}\n\n.footer-column:nth-child(1) { animation-delay: 0.1s; }\n.footer-column:nth-child(2) { animation-delay: 0.2s; }\n.footer-column:nth-child(3) { animation-delay: 0.3s; }\n.footer-column:nth-child(4) { animation-delay: 0.4s; }\n.footer-column:nth-child(5) { animation-delay: 0.5s; }\n\n/* Hover effect for footer sections */\n.footer-column:not(.footer-company):hover {\n  transform: translateY(-2px);\n  transition: transform 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
